import { render, staticRenderFns } from "./ContactFormAddress.vue?vue&type=template&id=006a2e46&"
import script from "./ContactFormAddress.vue?vue&type=script&lang=js&"
export * from "./ContactFormAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports